<template>
  <div>
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="商品名称"
          ><el-input
            size="small"
            v-model="searchForm.product_name"
            placeholder="请输入商品名称"
          ></el-input
        ></el-form-item>

        <el-form-item label="供应商来源"
          ><el-input
            size="small"
            v-model="searchForm.supply_name"
            placeholder="请输入供应商来源"
          ></el-input
        ></el-form-item>

        <el-form-item label="采购时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.buy_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item
          ><el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          ></el-form-item
        >
      </el-form>
    </div>
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick()"
        >添加</el-button
      >
      <el-button size="small" type="primary" @click="shuaixn()">刷新</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <!-- <el-table-column prop="procure_id" label="ID"></el-table-column> -->
          <el-table-column
            prop="product_name"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            prop="product_num"
            label="商品数量"
          ></el-table-column>
          <el-table-column prop="price" label="商品单价成本"></el-table-column>
          <el-table-column
            prop="supply_name"
            label="供应商来源"
          ></el-table-column>
          <el-table-column
            prop="total_price"
            label="采购物品总价"
          ></el-table-column>
          <el-table-column prop="buy_time" label="采购时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                @click="gobainji(scope.row)"
                type="success"
                size="small"
                >查看图片</el-button
              >
              <el-button @click="godelete(scope.row)" type="danger" size="small"
                >删除记录</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes,prev, pager, next, jumper"
          :total="totalDataNumber"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="添加采购记录"
      :visible.sync="dialogVisiblefxdq"
      class="dialogBox"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
      <el-form
        :model="addUserData"
        label-width="100px"
        ref="addUserData"
        :rules="rules"
      >
        <el-form-item label="商品名称" prop="product_name">
          <el-input
            v-model="addUserData.product_name"
            placeholder="请填写商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品数量" prop="product_num">
          <el-input
            v-model="addUserData.product_num"
            placeholder="请填写商品数量"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品单价" prop="price">
          <el-input
            v-model="addUserData.price"
            placeholder="请填写商品单价"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商来源" prop="supply_name">
          <el-input
            v-model="addUserData.supply_name"
            placeholder="请填写供应商"
          ></el-input>
        </el-form-item>
        <el-form-item label="采购日期" prop="buy_time">
          <el-date-picker
            v-model="addUserData.buy_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品图片" prop="product_images">
          <div class="hover_group pr">
            <el-upload
              class="avatar-uploader"
              multiple
              ref="upload"
              action="string"
              accept="image/jpeg,image/png,image/jpg,image/gif"
              :before-upload="onBeforeUploadImage"
              :http-request="UploadImage"
              :show-file-list="false"
              :on-change="fileChange"
            >
              <el-button size="small" icon="el-icon-upload" type="primary"
                >点击上传</el-button
              >
            </el-upload>
          </div>
          <div
            class=" d-r"
            style="width: fit-content; box-sizing: border-box; display: flex; flex-wrap: wrap;"
          >
            <div
              class="pr img-wrap p10"
              style="height: 100%;"
              v-for="item in product_images"
            >
              <img
                v-img-url="item"
                style="border-radius: 6px;border: solid 1px #d7e0e9;"
                height="100"
                alt="预览图"
              />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblefxdq = false">取 消</el-button>
        <el-button type="primary" @click="queding">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="查看采购记录"
      :visible.sync="dialogVisiblefxdq1"
      class="dialogBox"
      :destroy-on-close="true"
    >
      <el-form :model="addUserData1" label-width="100px" disabled>
        <el-form-item label="商品名称">
          <el-input
            v-model="addUserData1.product_name"
            placeholder="请填写商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品数量">
          <el-input
            v-model="addUserData1.product_num"
            placeholder="请填写商品数量"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品单价">
          <el-input
            v-model="addUserData1.price"
            placeholder="请填写商品单价"
          ></el-input>
        </el-form-item>
        <el-form-item label="供应商来源">
          <el-input
            v-model="addUserData1.supply_name"
            placeholder="请填写供应商"
          ></el-input>
        </el-form-item>
        <el-form-item label="采购日期">
          <el-date-picker
            v-model="addUserData1.buy_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品图片">
          <div
            class=" d-r"
            style="width: fit-content; box-sizing: border-box; display: flex; flex-wrap: wrap;"
          >
            <div
              class="pr img-wrap p10"
              style="height: 100%;"
              v-for="item in product_images"
            >
              <img
                v-img-url="item"
                style="border-radius: 6px;border: solid 1px #d7e0e9;"
                height="100"
                alt="预览图"
              />
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ProcureApi from "@/api/procure.js";
import FileApi from "@/api/file.js";

export default {
  data() {
    return {
      addUserData: {
        product_name: "",
        product_num: "",
        price: "",
        supply_name: "",
        buy_time: "",
        product_images: ""
      },
      addUserData1: {
        product_name: "",
        product_num: "",
        price: "",
        supply_name: "",
        buy_time: "",
        product_images: ""
      },
      product_images: [],
      /*验证规则*/
      rules: {
        product_name: [{ required: true, message: "请填写商品名称!" }],
        product_num: [{ required: true, message: "请填写商品数量!" }],
        price: [{ required: true, message: "请填写商品单价!" }],
        supply_name: [{ required: true, message: "请填写供应商!" }],
        buy_time: [{ required: true, message: "请选择采购日期!" }],
        product_images: [{ required: true, message: "上传商品图片!" }]
      },
      dialogVisiblefxdq: false,
      dialogVisiblefxdq1: false,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        product_name: "",
        supply_name: "",
        buy_time: ""
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /*选择上传图片*/
    fileChange(e) {
      console.log(e);
    },
    /*上传图片*/
    UploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: "图片上传中,请等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const formData = new FormData();
      formData.append("iFile", param.file);
      formData.append("group_id", self.activeType);
      formData.append("file_type", "image");
      FileApi.uploadFile(formData)
        .then(response => {
          loading.close();
          self.getData();
          param.onSuccess(); // 上传成功的图片会显示绿色的对勾
          // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
          console.log(response, "response");
          self.product_images.push(response.data.file_path);
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: "本次上传图片失败",
            type: "warning"
          });
          param.onError();
        });
    },
    /*选择图片之前*/
    onBeforeUploadImage(file) {
      return true;
    },
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    queding() {
      this.addUserData.product_images = this.product_images.join(",");
      this.$refs.addUserData.validate(valid => {
        if (!valid) return;
        console.log("error submit!!", this.addUserData);
        let params = {
          ...this.addUserData
        };
        ProcureApi.addInfo(
          {
            params: JSON.stringify(params)
          },
          true
        ).then(res => {
          console.log(res, "table");
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.dialogVisiblefxdq = false;
          this.getData();
        });
      });
    },
    // 添加
    addClick() {
      this.product_images = []
      this.dialogVisiblefxdq = true;
    },
    // 删除
    godelete(row) {
      console.log("删除", row.procure_id);
      this.$confirm("确定要删除当前记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let Params = {
            procure_id: row.procure_id
          };
          ProcureApi.delInfo(Params, true).then(res => {
            console.log(res, "table");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.getData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 打开编辑
    gobainji(row) {
      console.log(row);
      this.addUserData1 = row;
      this.product_images = row.product_images.split(",");
      this.dialogVisiblefxdq1 = true;
    },
    // 弹窗关闭
    handleClose() {
      this.addUserData.product_name = "";
      this.addUserData.product_num = "";
      this.addUserData.price = "";
      this.addUserData.supply_name = "";
      this.addUserData.buy_time = "";
      this.addUserData.product_images = "";
      this.product_images = [];
      this.dialogVisiblefxdq = false;
      this.dialogVisiblefxdq1 = false;
    },
    handleClose1() {
      this.addUserData1.product_name = "";
      this.addUserData1.product_num = "";
      this.addUserData1.price = "";
      this.addUserData1.supply_name = "";
      this.addUserData1.buy_time = "";
      this.addUserData1.product_images = "";
      this.product_images = [];
      this.dialogVisiblefxdq1 = false;
    },
    /*获取数据*/
    getData() {
      let Params = this.searchForm;
      Params.current_page = this.curPage; // 多少条
      Params.per_page = this.pageSize; // 第几页
      this.loading = true;
      ProcureApi.indexList(Params, true).then(res => {
        this.loading = false;
        console.log(res, "table");
        this.tableData = res.data.data;
        this.totalDataNumber = res.data.total;
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      console.log(val);
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      self.loading = true;
      this.getData();
    },
    /*搜索查询*/
    onSubmit() {
      console.log(this.searchForm, "this.searchForm");
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    }
  }
};
</script>

<style lang="scss">
.tjfxdq {
  margin-bottom: 15px;
}

.tjfxdq div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;
}

.tjfxdq div span {
  width: 100px;
}

.tjfxdq div div {
  width: 600px;
}

.anniu {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/procure/index/index.vue